<template>
  <div :class="['map2d',screenMode?'fullmap':'']">
    <div class="fullmap-title" v-if="screenMode"><img class="logo" src="@assets/img/logo.png"/> 谱恒能源管理平台</div>
    <!--主地图-->
    <div id="mainmap" class="t-map"></div>
    <!--站点属性显示-->
    <sitepanel :mainmap="mainmap" v-if="mainmap&&stationConfig" :stationConfig="stationConfig">
    </sitepanel>
    <!--实时管道-->
    <pipeline :mainmap="mainmap" :pipelineConfig="pipelineConfig" :stationConfig="stationConfig" :pipelineLayerData="pipelineLayerData"
      v-if="mainmap&&pipelineLayerData" v-on:colorSettingChange="colorSettingChange" ref="pipeline" @pipelineLoadComplete="pipelineLoadComplete">
    </pipeline>
    <!--色卡显示-->
    <colorcard :colorSetting="currentColorSetting" v-if="currentColorSetting"></colorcard>
    <!--模拟仿真-->
    <simulation :mainmap="mainmap" :stationConfig="stationConfig" v-if="stationConfig&&pipelineConfig" 
      :colorSetting="currentColorSetting" :pipelineConfig="pipelineConfig">
    </simulation>
    <!--鹰眼地图-->
    <overviewmap :mainmap="mainmap"  v-if="mainmap&&pipelineLayerData" ref="overviewmap" :pipelineLayerData="pipelineLayerData"></overviewmap>

    <!-- 全部显示管线 -->
    <div class="l-wrap allfeature-wrap">
        <div class="allfeature l-btn" @click="featureFullScreen">
            <img src="../../assets/img/full_screen.png"/>
        </div>
    </div>
    <!--全屏-->
    <div class="l-wrap fullscree-wrap">
        <div class="fullscree l-btn" @click="fullScreen">
            <i class="iconfont" v-if="screenMode">&#xe606;</i>
            <i class="iconfont" v-else>&#xe616;</i>
        </div>
    </div>

    <!--开启编辑-->
    <div class="l-wrap editor-wrap">
        <div class="editor editor-btn l-btn" @click="editorProperties">
            <i class="iconfont" v-if="!editorMode">&#xe630;</i>
            <i class="iconfont" v-else>&#xe60b;</i>
        </div>
        <div class="save editor-btn l-btn" @click="saveStationLabelConfig" v-if="editorMode">
            <i class="iconfont">&#xe60d;</i>
        </div>
    </div>
  </div>
</template>

<script>
import {getUserSetting,getPipelinelayer,setUserSetting} from "@api/map2d";

import TMap from "../../components/TMap";

import SitePanel from "./SitePanel";
import PipeLine from "./PipeLine";
import ColorCard from "./ColorCard";
import Simulation from "./Simulation";
import OverViewmap from "./OverviewMap";

import Feature from 'ol/Feature';
import LineString from 'ol/geom/LineString';

import DragPan from 'ol/interaction/DragPan'; // 拖动

import Valve from './Valve';// 开度信息

export default {
  name: "map2d",
  data() {
    return {
      mainmap:null, // 地图组件

      currentColorSetting:null, // 当前颜色色卡配置
      stationConfig:null, //站点配置信息
      pipelineConfig:null, // 管线配置

      screenMode:false, // 是否是全屏

      pipelineLayerData:null, //管道图层Geojson数据

      editorMode:false, //是否处于编辑模式
      dragOverlay:{
        offsetXY:[0,0], // 保存鼠标点击位置和overlay的停靠坐标点之间的偏移量
        overlay:null, // 点击并拖动的overlay
        feature:null, // overlay相关的feature
        ratio:null,
        domWidth:0,
        domHeight:0,
        offsetWidth:0,
        offsetHeight:0,
        offset:[0,0], // 这个是overlay上的停靠点和中心的偏移量
        overlayDom:null,
        anchor:"bottom-center",
      }
    };
  },
  components:{
    sitepanel:SitePanel, // 站点属性
    pipeline:PipeLine, // 管道
    colorcard:ColorCard, // 颜色色卡
    simulation:Simulation,// 模拟仿真
    overviewmap:OverViewmap, // 鹰眼地图
  },
  mounted(){
    this.$nextTick(()=>{
      // 加载地图
      let tmap=new TMap("mainmap",{
        center:[120.349,30.34],
        level:18,
        option:{
          zoomSlider:true // 显示zoomSlider
        }
      });
      this.mainmap=tmap;

      // 初始化用户配置
      this.initConfig();
    });
  },
  computed:{
      // 当前数据库
      db(){
          return this.$store.getters.db;
      }
  },
  watch:{
    db:function(){
      // 退出全屏
      this.fullScreen(false);
    }
  },
  methods:{
    // 初始化用户配置
    async initConfig(){
      // 获取管线图层数据
      this.getPipelinelayer();
      // 获取站点配置信息
      getUserSetting("station").then(data=>{
          // 保存站点配置信息
          if(data.status&&data.status==200){
              this.stationConfig=data.content;
          }
      });

      // 显示开度信息
      new Valve(this.mainmap,this.db.dburlname);


      // 获取管线的线段配置
      let pipedata=await getUserSetting("pipeline");
      if(pipedata.status!=200||!pipedata.content||Object.keys(pipedata.content).length<=0){
          this.pipelineConfig=null;
          return;
      }
      let pipelineConfig=pipedata.content;
      //构建线段的配置对象
      /* 根据线段的配置文件，最后组装成了这个对象
      {
          "id": 2,
          "linenumber": 2,
          "startnumber": 389,  //线段开始编号
          "endnumber": 599,
          "sublineArray":[
              {
              "startnumber": 155,
              "endnumber": 378,
              "dindex": 8
              },
              {
              "startnumber": 155,
              "endnumber": 378,
              "dindex": 8
              }
          ]
      }
      */
      let lineConfig={}; //管线配置数据
      if(pipelineConfig.length>0){
          var tempLength=0;
          var lineCount=pipelineConfig.length;
          for(var i=0;i<lineCount;i++){
              var temp=pipelineConfig[i];
              if(!lineConfig[temp.lineId]){
                  lineConfig[temp.lineId]=temp;
                  lineConfig[temp.lineId].sublineArray=[];
              }
              //构建子数组
              var subTemp={
                  "startIndex": temp.startIndex,
                  "endIndex":  temp.endIndex,
                  "dindex": tempLength
              }
              lineConfig[temp.lineId].sublineArray.push(subTemp);
              tempLength+=temp.endIndex-temp.startIndex+1;
          }
      }
      // 保存构建的数组
      this.pipelineConfig=lineConfig;
    },
    // 颜色设置改变
    colorSettingChange(currentColorSetting){
      this.currentColorSetting=currentColorSetting;
    },
    // 全屏展示
    featureFullScreen(){
      // 获取组件引用
      let pipeline=this.$refs.pipeline;
      if(pipeline){
        let extent=pipeline.$data.featureExtent;
        // 进行缩放
        this.mainmap.getView().fit(extent,this.mainmap.getSize());
      }
    },
    // 管线数据加载完成
    pipelineLoadComplete(){
      // 更新鹰眼地图图层
      // let $overviewmap=this.$refs.overviewmap;
      // $overviewmap.pipelineLayer=null;
      // let overviewMap=$overviewmap.overviewMap;
      // if(overviewMap){
      //   overviewMap.dispatchEvent("pipelinelayer");
      // }
    },
    // 获取管线图层数据
    async getPipelinelayer(){
        await getPipelinelayer().then(data=>{
            this.pipelineLayerData=data;
        })
    },

    // 全屏
    fullScreen(m){
      if(m instanceof MouseEvent){
        this.screenMode=!this.screenMode;
      }else{
        this.screenMode=m;
      }

      // 标题栏隐藏
      let $el=document;
      let top_menu=$el.querySelector(".top_menu"); //顶部菜单栏      
      // 左侧侧边栏
      let left_menu=$el.querySelector(".main-c .el-scrollbar");
      // 判断是否处于全屏模式
      if(this.screenMode){
        // 顶部菜单收起
        top_menu.classList.add('fullscreen','in');
        // 左侧菜单栏收起
        left_menu.classList.add('fullscreen','in');

        // 监听鼠标位置，当鼠标移出相关的区域后，关闭左侧菜单栏和顶部菜单栏
        $el.addEventListener("mousemove",this.mouseMove);

        // 激活全屏模式
         if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        }
      }else{
        left_menu.classList.remove('fullscreen','in','out');
        top_menu.classList.remove('fullscreen','in','out');
        // 移除全部的事件监听
        $el.removeEventListener("mousemove",this.mouseMove);

        // 退出全屏模式
        if (document.exitFullscreen&&document.fullscreenElement) {
          document.exitFullscreen();
        }
      }

      // 清除Dom引用，防止内存泄漏
      $el=null;
      top_menu=null; //顶部菜单栏      
      left_menu=null; // 左侧侧边栏
    },
    // 鼠标移动事件
    mouseMove(events){
       // 标题栏隐藏
      let $el=document;
      let top_menu=$el.querySelector(".top_menu"); //顶部菜单栏      
      // 左侧侧边栏
      let left_menu=$el.querySelector(".main-c .el-scrollbar");
      let clientY=events.clientY;
      // 鼠标移动到左边，和上部,弹出左侧和上部菜单
      let clientX=events.clientX;
      if(clientX<=10||clientY<=10){
        top_menu.classList.remove("in");
        top_menu.classList.add("out");
        left_menu.classList.remove("in");
        left_menu.classList.add("out");
      }
      // 移出左侧
      if(clientX>=180&&clientY>60){
        // 如果此时数据库选择菜单未打开,则关闭菜单
        let dbname=top_menu.querySelector(".dbname .is-opened");
        if(!dbname){
          top_menu.classList.remove("out");
          top_menu.classList.add("in");
          left_menu.classList.remove("out");
          left_menu.classList.add("in");
        }
      }

      // 清除Dom引用，防止内存泄漏
      $el=null;
      top_menu=null; //顶部菜单栏      
      left_menu=null; // 左侧侧边栏
    },

    // 开启属性框的位置编辑
    editorProperties(){
      this.editorMode=!this.editorMode;

      let dragPan=null;
      var that=this;
      let map=that.mainmap;

      // 获取站点图层
      let stationLayer=map.getLayerByName("station_layer");
      let stationSource=null;
      if(stationLayer){
        stationSource=stationLayer.getSource();
      }

      let overlayLineLayer=map.getLayerByName("overlayLineLayer_layer");
      // 判断图层是否存在
      if(!stationSource){
        console.log("图层不存在")
        return;
      }
      

      // 鼠标按下事件
      map.mousedownFun=map.mousdownFun||function (evtArray){
        // 使用事件代理的方式绑定鼠标点击Overlayer事件
        let offsetXY=that.dragOverlay.offsetXY; // 保存鼠标点击位置和overlay的停靠坐标点之间的偏移量
        let overlay=that.dragOverlay.overlay; // 点击并拖动的overlay
        let feature=that.dragOverlay.feature; // overlay相关的feature
        let ratio=that.dragOverlay.ratio||this.detectZoom();
        let domWidth=that.dragOverlay.domWidth;
        let domHeight=that.dragOverlay.domHeight;
        let offsetWidth=that.dragOverlay.offsetWidth;
        let offsetHeight=that.dragOverlay.offsetHeight;
        let offset=that.dragOverlay.offset; // 这个是overlay上的停靠点和中心的偏移量
        let overlayDom=that.dragOverlay.overlayDom;
        let anchor=that.dragOverlay.anchor;

        overlayDom=this;
        let overId=overlayDom.id;
        let featureId=overlayDom.dataset.number;
        // 获取地图上的overlay
        overlay=map.getOverlayById(overId);
        feature=stationSource.getFeatureById(featureId);

        let evt=evtArray[0];// 进行代理委托之后，事件参数变成了一个数组

        dragPan.setActive(false);
        overlay.set('dragging', true);

        // 获取最新坐标,绘制最新的连线
        let stationGeom=feature.getGeometry();
        let stationCoordinate=stationGeom.getCoordinates(); // 站点坐标
        let stationPixel=map.getPixelFromCoordinate(stationCoordinate); // 站点的屏幕像素值

        // 设置站点图标的坐标位置
        // 计算图标顶点的坐标，也就是绘制的连线，应该指向图标的顶点
        // 计算方法，也就是获取图标的旋转角度，获取站点原始坐标，图标的宽高为30x46
        // 根据三角函数，已知斜边，求两个直角标的宽高，就可以使用sin和cos三角函数关系
        let label=feature.get("label")||0;
        let radian = 0; // 角度转弧度
        let picOffsetX=0;
        let picOffsetY=0;
        switch(label){
            case 0:
                picOffsetX=0;
                picOffsetY=25;
                break;
            case 90:
                picOffsetX=25;
                picOffsetY=0;
                break;
            case 180:
                picOffsetX=0;
                picOffsetY=-25;
                break;
            case 270:
                picOffsetX=-25;
                picOffsetY=0;
                break;
            default:
                radian = label * (Math.PI/180); // 角度转弧度
                picOffsetX=parseInt(25*Math.sin(radian));
                picOffsetY=parseInt(25*Math.cos(radian));
                break;
        }
        let labelPixel=[stationPixel[0]+picOffsetX,stationPixel[1]-picOffsetY];
        let labelCoordinate=map.getCoordinateFromPixel(labelPixel);
        overlay.set("labelCoordinate",labelCoordinate);


        // // 获取事件点击的坐标值
        let evtCoord=map.getEventCoordinate(evt);
        let domCoord=overlay.get("overlayCoordinate")||feature.get("overlayCoordinate")||[0,0];

        // 计算鼠标点击位置和基点坐标(可能是div的左上角)之间的偏移量
        if(!domCoord){
            domCoord=stationCoordinate;
        }
        // 保存鼠标位置点和停靠坐标点的偏移量
        offsetXY=[evtCoord[0]-domCoord[0],evtCoord[1]-domCoord[1]];
        
        // 设置偏移量,为了应付奇葩需求，只能动态计算缩放比例，然后重新设置相应的overlay位置了
        // 如果执行了屏幕缩放，就要计算相应的缩放量，然后将offset相应的前去缩放量的一半，这样基本上可以进行相应位置的定位不变
        // 左上角还是左上角，右下角还是右下角
        domWidth=overlayDom.offsetWidth||0;
        domHeight=overlayDom.offsetHeight||0;
        offsetWidth=domWidth*ratio/2;
        offsetHeight=domHeight*ratio/2;

        // 面板的位置,底部的中间
        anchor=feature.get("anchor")||"bottom-center";
        switch (anchor) {
            case "bottom-left":
                offset=[10,-10];
                break;
            case "bottom-center":
                offset=[0,-40];
                break;
            case "bottom-right":
                offset=[-15,-20];
                break;
            case "center-left":
                offset=[10,0];
                break;
            case "center-right":
                offset=[-10,0];
                break;
            case "top-left":
                offset=[15,20];
                break;
            case "top-center":
                offset=[0,40];
                break;
            case "top-right":
                offset=[-15,20];
                break;
            default:
                feature.set("anchor","center-center");
                offset=[0,0];
                break;
        }

        // 保存点击的信息
        that.dragOverlay.offsetXY=offsetXY; // 保存鼠标点击位置和overlay的停靠坐标点之间的偏移量
        that.dragOverlay.overlay=overlay; // 点击并拖动的overlay
        that.dragOverlay.feature=feature; // overlay相关的feature
        that.dragOverlay.ratio=that.detectZoom();
        that.dragOverlay.domWidth=domWidth;
        that.dragOverlay.domHeight=domHeight;
        that.dragOverlay.offsetWidth=offsetWidth;
        that.dragOverlay.offsetHeight=offsetHeight;
        that.dragOverlay.offset=offset; // 这个是overlay上的停靠点和中心的偏移量
        that.dragOverlay.overlayDom=overlayDom;
        that.dragOverlay.anchor=anchor;
      }


      // 鼠标弹起事件
      map.pointerupFun=map.pointerupFun||function (evt) {
        // 使用事件代理的方式绑定鼠标点击Overlayer事件
        let offsetXY=that.dragOverlay.offsetXY; // 保存鼠标点击位置和overlay的停靠坐标点之间的偏移量
        let overlay=that.dragOverlay.overlay; // 点击并拖动的overlay
        let feature=that.dragOverlay.feature; // overlay相关的feature
        let domWidth=that.dragOverlay.domWidth;
        let domHeight=that.dragOverlay.domHeight;
        let offsetWidth=that.dragOverlay.offsetWidth;
        let offsetHeight=that.dragOverlay.offsetHeight;
        let offset=that.dragOverlay.offset; // 这个是overlay上的停靠点和中心的偏移量
        let overlayDom=that.dragOverlay.overlayDom;
        let anchor=that.dragOverlay.anchor;


        dragPan.setActive(true);
        if (overlay&&overlay.get('dragging') === true) {
            overlay.set('dragging', false);

            // 获取最新的overlayer坐标
            let coor=[evt.coordinate[0]-offsetXY[0],evt.coordinate[1]-offsetXY[1]];
            overlay.setPosition(coor);
            // 保存最新坐标，因为使用getPostion()方法无法获取overlay的坐标
            overlay.set("overlayCoordinate",coor);
        }

        // 保存点击的信息
        that.dragOverlay.offsetXY=offsetXY; // 保存鼠标点击位置和overlay的停靠坐标点之间的偏移量
        that.dragOverlay.overlay=overlay; // 点击并拖动的overlay
        that.dragOverlay.feature=feature; // overlay相关的feature
        that.dragOverlay.ratio=that.detectZoom();
        that.dragOverlay.domWidth=domWidth;
        that.dragOverlay.domHeight=domHeight;
        that.dragOverlay.offsetWidth=offsetWidth;
        that.dragOverlay.offsetHeight=offsetHeight;
        that.dragOverlay.offset=offset; // 这个是overlay上的停靠点和中心的偏移量
        that.dragOverlay.overlayDom=overlayDom;
        that.dragOverlay.anchor=anchor;
      }
      // 鼠标移动事件
      map.pointermoveFun=map.pointermoveFun||function(evt) {
        // 使用事件代理的方式绑定鼠标点击Overlayer事件
        let offsetXY=that.dragOverlay.offsetXY; // 保存鼠标点击位置和overlay的停靠坐标点之间的偏移量
        let overlay=that.dragOverlay.overlay; // 点击并拖动的overlay
        let feature=that.dragOverlay.feature; // overlay相关的feature
        let domWidth=that.dragOverlay.domWidth;
        let domHeight=that.dragOverlay.domHeight;
        let offsetWidth=that.dragOverlay.offsetWidth;
        let offsetHeight=that.dragOverlay.offsetHeight;
        let offset=that.dragOverlay.offset; // 这个是overlay上的停靠点和中心的偏移量
        let overlayDom=that.dragOverlay.overlayDom;
        let anchor=that.dragOverlay.anchor;


        if (overlay&&overlay.get('dragging') === true) {
          // 删除已有的连线
          let lineFeature=overlay.get("line");
          let source=overlayLineLayer.getSource();
          if(lineFeature){
              source.removeFeature(lineFeature);
          }

          // 将当前的鼠标位置减去偏移量,得到基点应该所处的位置
          // 基点位置，即overlay停靠到图标的位置，
          // 因为会有偏移量的限制，所以求出鼠标点的位置和停靠点的位置的偏移量，还要加上overlay的offset
          let coor=[evt.coordinate[0]-offsetXY[0],evt.coordinate[1]-offsetXY[1]];
          overlay.setPosition(coor);
          // 保存最新坐标，因为使用getPostion()方法无法获取overlay的坐标
          overlay.set("overlayCoordinate",coor);
          // 同时保存到feature属性中
          feature.set("overlayCoordinate",coor);

          // 计算偏移量,从基点位置，反求停靠点位置坐标
          let overlayPixel=map.getPixelFromCoordinate(coor);
          // 保存像素点坐标
          overlay.set("overlayPixel",overlayPixel);
          feature.set("overlayPixel",overlayPixel);

          overlayPixel=[overlayPixel[0]+offset[0],overlayPixel[1]+offset[1]];

          // 根据最新的停靠点的位置，计算剩余的停靠点，比如bottom-center的坐标，top-center的坐标，对比各个坐标，选最靠近label顶点的值作为最后的停靠点
          let labelCoordinate=overlay.get("labelCoordinate"); // label停靠点的位置
          let labelPixel=map.getPixelFromCoordinate(labelCoordinate);// 获取label点的坐标值

          overlayPixel=that.calculateClosestPoint(overlayPixel,labelPixel,anchor,offsetWidth,offsetHeight); // 计算最新的屏幕像素位置
          // 求最新的停靠点的图上坐标
          coor=map.getCoordinateFromPixel(overlayPixel);

          // 绘制虚线,从overlay的基点位置，到图标的末点位置
          if(labelCoordinate){
              lineFeature = new Feature({
                  geometry: new LineString([coor,labelCoordinate])
              });
              overlay.set("line",lineFeature);
              source.addFeature(lineFeature);
          } 
        }

        // 保存点击的信息
        that.dragOverlay.offsetXY=offsetXY; // 保存鼠标点击位置和overlay的停靠坐标点之间的偏移量
        that.dragOverlay.overlay=overlay; // 点击并拖动的overlay
        that.dragOverlay.feature=feature; // overlay相关的feature
        that.dragOverlay.ratio=that.detectZoom();
        that.dragOverlay.domWidth=domWidth;
        that.dragOverlay.domHeight=domHeight;
        that.dragOverlay.offsetWidth=offsetWidth;
        that.dragOverlay.offsetHeight=offsetHeight;
        that.dragOverlay.offset=offset; // 这个是overlay上的停靠点和中心的偏移量
        that.dragOverlay.overlayDom=overlayDom;
        that.dragOverlay.anchor=anchor;
      }
      // 如果处于编辑模式
      if(this.editorMode){

        // 获取拖动对象
        map.getInteractions().forEach(function(interaction){
            if (interaction instanceof DragPan) {
                dragPan = interaction;
            }
        });       

        this.eventDelegate("#mainmap",".ztOverlayWarp .ztOverlay",'mousedown',map.mousedownFun)
        // 监听地图鼠标移动事件
        map.on('pointermove', map.pointermoveFun);
        // 监听鼠标释放事件
        map.on('pointerup', map.pointerupFun);
      }else{
        // 解除事件绑定
        let mapDom=this.$el.querySelector("#mainmap");
        mapDom.removeEventListener("mousedown",mapDom.mousedown);        
        map.un("pointermove",map.pointermoveFun)
        map.un("pointerup",map.pointerupFun);

        // 重新启用地图拖动
        map.getInteractions().forEach(function(interaction){
            if (interaction instanceof DragPan) {
                dragPan = interaction;
                dragPan.setActive(true);  
            }
        });
        // 清除Dom引用
        mapDom=null;
      }
    },
    eventDelegate(parentSelector, targetSelector, events, foo) {
      // 触发执行的函数
      function triFunction (e) {
        // 兼容性处理
        var event = e || window.event;

        // 获取到目标阶段指向的元素
        var target = event.target || event.srcElement;

        // 获取到代理事件的函数
        var currentTarget = event.currentTarget;
        // 遍历外层并且匹配
        while (target !== currentTarget) {
          // 判断是否匹配到我们所需要的元素上
          if (target.matches(targetSelector)) {
            var sTarget = target;
            // 执行绑定的函数，注意 this
            foo.call(sTarget, Array.prototype.slice.call(arguments))
          }
          target = target.parentNode;
        }
      }
      // 如果有多个事件的话需要全部一一绑定事件
      events.split('.').forEach(function (evt) {
        // 多个父层元素的话也需要一一绑定
        Array.prototype.slice.call(document.querySelectorAll(parentSelector)).forEach(function ($p) {
          $p.addEventListener(evt, triFunction);

          $p[evt]=triFunction;
        });
      });
    },
    // 计算dom的缩放比
    detectZoom(){
        let ratio = 0,
        screen = window.screen,
        ua = navigator.userAgent.toLowerCase();
        if (window.devicePixelRatio !== undefined) {
            ratio = window.devicePixelRatio;
        }
        else if (~ua.indexOf('msie')) {
            if (screen.deviceXDPI && screen.logicalXDPI) {
                ratio = screen.deviceXDPI / screen.logicalXDPI;
            }
        }
        else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
            ratio = window.outerWidth / window.innerWidth;
        }

        if (ratio) {
            ratio = Math.round(ratio * 100);
        }
        ratio=ratio/100;
        if(ratio>1){
            ratio=1;
        }
        return ratio;
    },
    /** 计算最近停靠点
     * overlaydatum 基准点
     * anchor 停靠方式
     * offsetWidth 面板宽度
     * offsetHeith 面板长度
     */
    calculateClosestPoint(overlaydatum,labeldatum,anchor,offsetWidth,offsetHeight){
        let x1=overlaydatum[0];
        let x2=overlaydatum[0];
        let x3=overlaydatum[0];
        let y1=overlaydatum[1];
        let y2=overlaydatum[1];
        let y3=overlaydatum[1];
        switch (anchor) {
            case "bottom-left":
              x1=overlaydatum[0];
              x2=overlaydatum[0]+offsetWidth;
              x3=overlaydatum[0]+2*offsetWidth;
              y1=overlaydatum[1]-2*offsetHeight;
              y2=overlaydatum[1]-offsetHeight;
              y3=overlaydatum[1];
              break;
            case "bottom-center":
              x1=overlaydatum[0]-offsetWidth;
              x2=overlaydatum[0];
              x3=overlaydatum[0]+offsetWidth;
              y1=overlaydatum[1]-2*offsetHeight;
              y2=overlaydatum[1]-offsetHeight;
              y3=overlaydatum[1];
              break;
            case "bottom-right":
              x1=overlaydatum[0]-2*offsetWidth;
              x2=overlaydatum[0]-offsetWidth;
              x3=overlaydatum[0];
              y1=overlaydatum[1]-2*offsetHeight;
              y2=overlaydatum[1]-offsetHeight;
              y3=overlaydatum[1];
              break;
            case "center-left":
              x1=overlaydatum[0];
              x2=overlaydatum[0]+offsetWidth;
              x3=overlaydatum[0]+2*offsetWidth;
              y1=overlaydatum[1]-offsetHeight;
              y2=overlaydatum[1];
              y3=overlaydatum[1]+offsetHeight;
              break;
            case "center-right":
              x1=overlaydatum[0]-2*offsetWidth;
              x2=overlaydatum[0]-offsetWidth;
              x3=overlaydatum[0];
              y1=overlaydatum[1]-offsetHeight;
              y2=overlaydatum[1];
              y3=overlaydatum[1]+offsetHeight;
              break;
            case "top-left":
              x1=overlaydatum[0];
              x2=overlaydatum[0]+offsetWidth;
              x3=overlaydatum[0]+2*offsetWidth;
              y1=overlaydatum[1];
              y2=overlaydatum[1]+offsetHeight;
              y3=overlaydatum[1]+2*offsetHeight;
              break;
            case "top-center":
              x1=overlaydatum[0]-offsetWidth;
              x2=overlaydatum[0];
              x3=overlaydatum[0]+offsetWidth;
              y1=overlaydatum[1];
              y2=overlaydatum[1]+offsetHeight;
              y3=overlaydatum[1]+2*offsetHeight;
              break;
            case "top-right":
              x1=overlaydatum[0]-2*offsetWidth;
              x2=overlaydatum[0]-offsetWidth;
              x3=overlaydatum[0];
              y1=overlaydatum[1];
              y2=overlaydatum[1]+offsetHeight;
              y3=overlaydatum[1]+2*offsetHeight;
              break;
            default:
              x1=overlaydatum[0]-offsetWidth;
              x2=overlaydatum[0];
              x3=overlaydatum[0]+offsetWidth;
              y1=overlaydatum[1]-offsetHeight;
              y2=overlaydatum[1];
              y3=overlaydatum[1]+offsetHeight;
              break;
        }
        // 求最靠近label的x位置
        if(labeldatum[0]<=x1){
            overlaydatum[0]=x1;
        }else if(labeldatum[0]>=x3){
            overlaydatum[0]=x3;
        }else if(labeldatum[0]>x1&&labeldatum[0]<x3){
            overlaydatum[0]=x2;
        }
        // 求最靠近label的y位置
        if(labeldatum[1]<=y1){
            overlaydatum[1]=y1;
        }else if(labeldatum[1]>=y3){
            overlaydatum[1]=y3;
        }else if(labeldatum[1]>y1&&labeldatum[1]<y3){
            overlaydatum[1]=y2;
        }
        return overlaydatum;
    },
    // 保存用户配置
    saveStationLabelConfig(){
        // 将用户设置保存到远程服务器
        let stationConfig=this.stationConfig;
        stationConfig.layer=stationConfig.layer||{};

        // 获取图层信息
        let stationLayer=this.mainmap.getLayerByName("station_layer");
        let stationSource=null;
        if(stationLayer){
          stationSource=stationLayer.getSource();
        }else{
          console.log("站点图层不存在");
          return;
        }

        let features=stationSource.getFeatures();
        for(let i=0;i<features.length;i++){
            let feature=features[i];
            let coor=feature.get("overlayCoordinate");
            if(coor){
                // 获取id号
                let SiteNo=feature.get("id");
                let stationLC=stationConfig.layer[SiteNo]||{};
                stationLC.overlayCoordinate=coor;
                stationConfig.layer[SiteNo]=stationLC;
            }
        }
        setUserSetting("station",JSON.stringify(this.stationConfig)).then(data=>{
            if(data.status&&data.status==200){
                this.$message({
                    message:"用户配置保存成功",
                    type:"success"
                })
            }
        });
    },
  }
};
</script>

<style lang="scss">
.map2d{
  color: black;
  position: relative;
  height: 100%;
  width: 100%;

  /*地图放大缩小和比例尺*/
  .t-map {
      z-index: 0;
      width: 100%;
      height: 100%;
      position: fixed;
      background: #fff;

      .ol-zoom {
        position: absolute;
        left: .5em;
        z-index: 100;

        .ol-zoom-in{
          top: 60px;
          position:absolute;
          border-radius: 4px;
        }

        .ol-zoom-out{
          top:290px;
          position:absolute;
          border-radius: 4px;
        }
    }

    /** 滑动条 */
    .ol-zoomslider{
      top: 95px;
      width: 8px;
      left: 20px;
      left: 16px;
      background: #fff;
      border: 1px solid #afaeae;

      button{
        transform: translateX(-10px);
      }
    }
    .ol-control button {
        background: #fff;
        color: #000;
        margin: 0;
        font-size: 1rem;
        cursor: pointer;
        border: 1px solid #2aade4;
        outline: none;
    }
    .ol-touch .ol-control button{
        font-size:1.5rem;
    }

    .ol-control .zoom-bar-in {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: 1px solid #aaa;
    }

    .ol-control .zoom-bar-out {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

  }
  
  /*全部显示*/
  .l-wrap{
      position: absolute;
      bottom: 2rem;
      left: 0.7rem;
      z-index: 1000;
      cursor:pointer;
      left: 20px;
      margin: 0px auto;
  }
  .l-btn{
      width: 40px;
      text-align: center;
      color: #fff;
      border-radius: 50%;
      font-size: 0.3rem;
      color:#4E84FF;
      line-height: 40px;
      background: #fff;
      img{
          width:100%;
          height:100%;
      }
  }
  .fullscree-wrap{
      bottom: 5rem;
  }

  /** 开启编辑模式 */
  .editor-wrap{
    bottom:8rem;

    .editor-btn{
      display: inline-block;
    }
    .save{
      margin-left: 5px;
    }
  }

  &.fullmap{
    position: fixed;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;

    .fullmap-title{
      position: absolute;
      line-height: 40px;
      height: 40px;
      z-index: 100;
      color: #E7BA71;
      font-size: 18px;
      margin: 10px;
      left: 15px;

      img{
        height: 100%;
      }
    }
  }
}
/**组件外的样式 */
// 菜单
.top_menu.fullscreen{
  position: fixed;
  z-index: 1000;
  width: 100%;
}
.top_menu.fullscreen.in{
  top: -70px;
  transition: all 1s ease 0s;
}
.top_menu.fullscreen.out{
  top: 0px;
  transition: all 1s ease 0s;
}
.el-scrollbar.fullscreen{
  position: fixed;
  z-index: 1000;
  height: 100%;
  background: #fff;
}
.el-scrollbar.fullscreen.in{
  left: -300px;
  transition: all 1s ease 0s;
}
.el-scrollbar.fullscreen.out{
  left: 0px;
  transition: all 1s ease 0s;
}
</style>
